'use client';
import { useState, useEffect } from 'react';
// Custom event name constant
const OTEL_TRACE_EVENT = 'otel:trace';
/**
 * OpenTelemetry Trace Viewer component for development
 *
 * A lightweight distributed tracing inspector for debugging:
 * - React server actions
 * - DB calls
 * - External API calls
 * - Latency waterfall
 * - Cache hits/misses
 * - Edge ↔ Server ↔ Browser transitions
 *
 * @example
 * ```tsx
 * import { OtelTraceViewer } from '@sandstone/dev-tools/otel-trace-viewer';
 *
 * <OtelTraceViewer />
 * ```
 */
export function OtelTraceViewer({ enabled }) {
    const shouldLoad = enabled ?? process.env.NODE_ENV === 'development';
    const [_traces, setTraces] = useState([]);
    useEffect(() => {
        if (!shouldLoad) {
            return;
        }
        // Listen for custom trace events
        const handleTrace = (event) => {
            setTraces(prev => [...prev.slice(-50), event.detail]); // Keep last 50
        };
        window.addEventListener(OTEL_TRACE_EVENT, handleTrace);
        return () => {
            window.removeEventListener(OTEL_TRACE_EVENT, handleTrace);
        };
    }, [shouldLoad]);
    if (!shouldLoad) {
        return null;
    }
    return null; // Traces are displayed in the dev-tools panel
}
